import React from 'react';
import './Button.scss';
const Button = (props) => {
  let classes = ['btn'];
  const { action, type, label, customClass,className, ...newProps } = props;

  if(customClass) {
    classes.push(customClass);
  }

  if (className) {
    classes.push(className);
  }
  switch (type) {
    case 'primary':
      classes.push('lebara-button primary');
      break;
    case 'secondary':
      classes.push('lebara-button');
      break;
    case 'yellow':
      classes.push('lebara-button yellow');
      break;
    case 'third':
      classes.push('btn-third');
      break;
    case 'link':
      classes.push('btn-link');
      break;
    default:
      classes.push('lebara-button primary');
  }

  return (
    <input
      type={props.sumbit ? 'submit' : 'button'}
      className={classes.join(' ')}
      disabled={props.disabled ? 'disabled' : null}
      onClick={props.disabled ? undefined : action}
      defaultValue={label}
      {...newProps}
    />
  );
};

export default Button;
